<template>
  <b-nav-item-dropdown right no-caret class="mailbox icons">
    <!-- Using 'button-content' slot -->
    <template #button-content v-if="!visible">
      <span class="mr-1" id="myStyle2">{{ username }}</span>
      <feather type="user" style="padding-right: 2.5em" class="feather-sm">
      </feather>
    </template>
    <template #button-content v-else>
      <span class="mr-1" id="myStyle3">{{ username }}</span>
      <feather type="user" style="padding-right: 2.5em" class="feather-sm">
      </feather>
    </template>
    <b-dropdown-text class="bg-info text-white">
      <div class="d-flex align-items-center py-2">
        <feather type="user"></feather>
        <div class="ml-3">
          <h4 class="mb-0 text-white">{{ username }}</h4>
        </div>
      </div>
    </b-dropdown-text>
    <!--Boton regresar a vista master-->
    <b-dropdown-item v-if="botonMasterVisible" class="d-flex align-items-center" @click="volverVistaMaster">
      <feather type="eye-off" style="stroke-width: 2" class="feather-sm mr-2 mb-n1">
      </feather>{{ $t("vistaMaster") }}
    </b-dropdown-item>
    <!-- Habilitar sonido en el sistema -->
    <b-dropdown-item class="d-flex align-items-center">
      <b-form-checkbox style="position: static" switch size="sm" v-model="sonido"
        @click.native="activaSonidoNotificacion" v-b-tooltip.hover="hoverHabilitado(sonido)">{{ $t("notifSonoras") }}
      </b-form-checkbox>
    </b-dropdown-item>
    <!-- Habilitar modo oscuro -->
    <b-dropdown-item class="d-flex align-items-center">
      <b-form-checkbox style="position: static" switch size="sm" v-model="tema" :set="(titulo = hoverHabilitado(tema))"
        @click.native="cambiarTema" v-b-tooltip.hover="hoverHabilitado(tema)">{{ $t("temaOscuro") }}
      </b-form-checkbox>
    </b-dropdown-item>
    <!-- Habilitar cambio de idioma del sistema -->
    <b-dropdown-item class="d-flex align-items-center">
      <b-form-checkbox style="position: static" switch size="sm" v-model="isEnglish"
        :set="(titulo = hoverHabilitado(isEnglish))" @click.native="cambiarIdioma"
        v-b-tooltip.hover="hoverHabilitado(isEnglish)">{{ $t("idioma") }}
      </b-form-checkbox>
    </b-dropdown-item>
    <!--Cerrar sesion-->
    <b-dropdown-item class="d-flex align-items-center" @click.native="logout">
      <feather type="log-out" class="feather-sm mr-2 mb-n1"></feather>
      {{ $t("cerarSesion") }}
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import UsersDataService from "../../../services/UsersDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Crypto from "../../../services/Crypto";
import LoginController from "../../../controllers/LoginController";

import { generalSweetAlert } from "../../../utils/Utils";

export default {
  props: {
    username: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    sonido: {
      type: Boolean,
      required: true,
    },
    tema: {
      type: Boolean,
      required: true,
    },
    isEnglish: {
      type: Boolean,
      required: true,
    },
    botonMasterVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      key: sessionStorage.getItem("key"),
    };
  },
  methods: {
    hoverHabilitado(hab) {
      if (hab) return this.$t("Deshabilitar");
      else return this.$t("Habilitar");
    },

    async cambiarTema() {
      try {
        const response = await UsersDataService.habilitarTemaOscuro();
        const decoded = await Crypto.desencriptar(response.data, this.key);

        if (decoded.temaOscuro) {
          const mensaje = this.$t("poptemaOscuro", { frase: this.$t("h") });
          generalSweetAlert(mensaje, "success");
        } else {
          const mensaje = this.$t("poptemaOscuro", { frase: this.$t("desh") });
          generalSweetAlert(mensaje, "success");
        }
      } catch (error) {
        console.error("Error en la funcion cambiarTema: ", error)
        generalSweetAlert(this.$t("Gral.msgErrorDesconocido"), "error");
      }

      this.$emit("cambiarTema");
    },

    async cambiarIdioma() {
      try {
        await UsersDataService.habilitarCambioIdioma();
      } catch (error) {
        console.error("Error en la funcion cambiarIdioma: ", error)
        generalSweetAlert(this.$t("Gral.msgErrorDesconocido"), "error");
      }

      this.$emit("cambiarIdioma");
    },

    async activaSonidoNotificacion() {
      try {
        const response = await UsersDataService.habilitarAlarmaAudible();
        const decoded = await Crypto.desencriptar(response.data, this.key);

        if (decoded.alarmaAudible) {
          const mensaje = this.$t('popAlarmaSonora', { frase: this.$t('h') })
          generalSweetAlert(mensaje, "success");

        } else {
          const mensaje = this.$t('popAlarmaSonora', { frase: this.$t('desh') })
          generalSweetAlert(mensaje, "success");
        }
      } catch (error) {
        console.error("Error en la funcion activaSonidoNotificacion : ", error)
        generalSweetAlert(this.$t("Gral.msgErrorDesconocido"), "error");
      }

      this.$emit("activaSonidoNotificacion");
    },

    async logout() {
      localStorage.setItem("pointNotificacion", "false");
      const userSession = JSON.parse(sessionStorage.getItem("usuarioLogueado"));
      if (userSession !== null) {
        await this.registrarConfiguracionBitacora(userSession)
      }
    },

    async registrarConfiguracionBitacora(userSession) {
      try {
        const data = {
          usuario: userSession,
          accion: 'Cierre de sesión' + sessionStorage.infoDevice,
          fechaCreacion: new Date(),
          tipo: "accion",
        };

        const response = await AccionesDataService.create(data, this.key)

        if (response.status === 201) {
          // Avisa al servidor para liberar la cuenta antes de borrar el token local,
          // así queda disponible de inmediato para volver a iniciar sesión.
          await this.notificarCierreSesionAlServidor();
          // se cierra sesión y se borran todas las variables almacenada en localStorage
          this.borrarDatosSessionStorage()
          this.$router.replace({ name: 'Login' });
        }

      } catch (error) {
        console.log('error', error);
      }
    },

    async notificarCierreSesionAlServidor() {
      try {
        const token = sessionStorage.getItem('token');
        if (token) {
          await LoginController.eliminarToken(token, localStorage.getItem('tokenPush'));
        }
      } catch (error) {
        // No debe impedir que el usuario cierre sesión localmente aunque falle el aviso al servidor.
        console.log('Error al notificar cierre de sesión al servidor: ', error);
      }
    },

    volverVistaMaster() {
      this.$emit("volverVistaMaster")
    },

    borrarDatosSessionStorage() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('username')
      sessionStorage.removeItem('idRol')
      sessionStorage.removeItem('usuarioFiltro')
      sessionStorage.removeItem('nombreUsuario')
      sessionStorage.removeItem('id_user')
      sessionStorage.removeItem('areaUser')
      sessionStorage.removeItem('user_')
      sessionStorage.removeItem('email')
      sessionStorage.removeItem('banMonitoreo')
      sessionStorage.removeItem('usuarioLogueado')
      sessionStorage.removeItem('banConfig')
      sessionStorage.removeItem('rol')
      sessionStorage.removeItem('ubicacionTiempoReal')
      sessionStorage.removeItem('key');
      localStorage.removeItem('aciqui_instance');
      localStorage.removeItem('tokenPush');
    },

    goToAyuda(){
      this.$router.replace({ name: 'Ayuda' });
    }

  },
};
</script>

<style scoped>
#myStyle2,
#myStyle3 {
  font-weight: 700;
}
</style>
